import React from "react";
import "./Home.css";

import Intro from "../components/Intro";
import AllInOne from "../components/new/allInOne/AllInOne";
import NavLight from "../components/NavLight";
import CeoMsg from "../components/new/ceoMsg/CeoMsg";
import AsSoon from "../components/new/asSoon/AsSoon";
import BuiltPM from "../components/new/builtPM/BuiltPM";
import Demo from "../components/Demo";
import ProductTrial from "../components/ProductTrial";
import BlogPosts from "../components/BlogPosts";
import Steps from "../components/new/steps/Steps";
import {meta} from "../assets/meta/meta";
import {CustomMetaHelmet} from "../components/CustomMetaHelmet";

function Home() {

    return (
        <main className="Home">
            <CustomMetaHelmet meta={meta.home}/>
            <NavLight/>
            <Intro/>
            <AllInOne/>
            <CeoMsg/>
            <AsSoon/>
            <Steps/>
            <ProductTrial/>
            <BuiltPM/>
            <Demo/>
            <BlogPosts/>
        </main>
    );
}

export default Home;
